import { useState, useEffect } from "react"

export default function IrregularChoice(props) {
  
  
const [showReasons, setShowReasons] = useState(false)

const [videoOption, setVideoOption] = useState(props.videosList.irregular)

useEffect(() => {
  props.setLensTargetNear(false)
  props.setLensOption("Cataract vision")
  setVideoOption(props.videosList.irregular)
}, [props.spanish]);

const optionStyleTrue = {
    width: "90%",
    border: "1px solid #292929",
    margin: "10px auto 0 auto",
    color: "#292929",
    padding: "14px 8px",
    borderRadius: "5px",
    fontSize: "14px",
    fontWeight: "400",
    background: "#f1f1f1",
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",
  }

  const optionStyleFalse = {
    width: "90%",
    border: "1px solid #bbb",
    margin: "10px auto 0 auto",
    color: "#888",
    padding: "14px 8px",
    borderRadius: "5px",
    fontSize: "14px",
    fontWeight: "400",
    background: "#FFF",
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",
  }

  let nameStyle = {
    margin: '0',
  }

  let showReasonsStyle = {
    margin: '10px 0 0 10px',
    color: '#888',
    fontSize: '14px',
    fontWeight: '400',
    background: '#FFF',
    cursor: 'pointer',
    width: "100%"
  }

  let liWarnStyle = {
    margin: '0 0 10px 0',
  }

  return (
    <>

    <div
      style={{
        position: "relative",
        width: "100%",
        maxWidth: "640px",
        paddingTop: "56.25%", // 16:9 aspect ratio
        margin: "0 auto",
        
      }}
    >
      <iframe
        src={videoOption}
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          borderTop: "1px solid #000",
        }}
        title="Irregular"
        allowFullScreen
      />
    </div>

      {/* Lens options */}
      <div>


        <div
          style={
            props.lensOption === "Cataract vision" 
              ? optionStyleTrue
              : optionStyleFalse
          }
          onClick={() => {
            props.setLensOption("Cataract vision")
          }}
        >
            {props.spanish === true ? 'Visión con cataratas': 'Cataract vision'}
        </div> 

        <div
          style={(!props.lensTargetNear && props.lensOption !== "Cataract vision") ? optionStyleTrue : optionStyleFalse}
          onClick={() => {
            props.setLensOption(props.monofocalLens?.lens_name)
            props.setLensTargetNear(false)
            props.setRefractive(false)
          }}
        >
          <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                }}
            >
                <p style={nameStyle}> 
                    {props.spanish === true ? 'Prefiero ver de lejos': 'Prefer seeing far-away'} 
                </p>
            </div>
        </div>

        
        <div
          style={(props.lensTargetNear && props.lensOption !== "Cataract vision") ? optionStyleTrue : optionStyleFalse}
          onClick={() => {
            props.setLensOption(props.monofocalLens?.lens_name)
            props.setLensTargetNear(true)
            props.setRefractive(false)
          }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                }}
            >
                <p style={nameStyle}> 
                    {props.spanish === true ? 'Prefiero ver de cerca': 'Prefer seeing up-close'}
                </p>
            </div>
        </div>

      </div>
        
    </>
  )
}






//  <>
//             {
//               showReasons === true ? (
//                 <div 
//                   onClick={() => setShowReasons(false)}
//                   style={showReasonsStyle}
//                 >
//                   Click to hide reasons
//                 </div>
//               ) : (
//                 <div 
//                   onClick={() => setShowReasons(true)}
//                   style={showReasonsStyle}
//                 >
//                   Click if you want to see the specifics on your eye
//                 </div>
//               )
//             }
        
//             { showReasons === true && (
//               <ul>
//                 {
//                   (props.lensParamWarningList || []).map((param, i) => {
//                     const matchingContra = (props.lensContraWarningList || []).find(
//                       contra => contra.name === param.name
//                     );
        
//                     const combinedWarnings = matchingContra
//                       ? `${param.warnings} Your eye's ${matchingContra.warning} limits the use of this lens`
//                       : param.warnings;
        
//                     return (
//                       <li key={i} style={liWarnStyle}>
//                         <span style={{ fontWeight: '600' }}>{param.name}</span>: {combinedWarnings}
//                       </li>
//                     );
//                   })
//                 }
//               </ul>
//             )}
//           </>